import { useState } from "react";
import { apiDelete, ApiResponse, ApiError } from "../../services/api.service";

interface UseRemoveMemberReturn {
	removeMember: (groupId: number, memberExtraId: number) => Promise<boolean>;
	loading: boolean;
	error: string | null;
}

/**
 * Custom hook to remove a member from a group
 * @returns Remove member function, loading state, and error state
 */
export function useRemoveMember(): UseRemoveMemberReturn {
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);

	const removeMember = async (groupId: number, memberExtraId: number): Promise<boolean> => {
		try {
			setLoading(true);
			setError(null);

			const response: ApiResponse<null> = await apiDelete<null>(
				`/groups/${groupId}/members/${memberExtraId}`
			);

			if (response.success) {
				return true;
			} else {
				setError(response.error || "Failed to remove member from group");
				return false;
			}
		} catch (err) {
			if (err instanceof ApiError) {
				setError(err.message);
			} else if (err instanceof Error) {
				setError(err.message);
			} else {
				setError("An unexpected error occurred while removing member");
			}
			return false;
		} finally {
			setLoading(false);
		}
	};

	return {
		removeMember,
		loading,
		error,
	};
}